import apiClient from "./client";

/**
 * Scheduled Emails API service
 * Global Admin only — manage email queue, view sent emails, send test emails.
 */
export const scheduledEmailsApi = {
  /**
   * Get paginated list of scheduled emails with optional filters
   */
  async getEmails({
    status = null,
    emailType = null,
    search = null,
    page = 1,
    pageSize = 25,
  } = {}) {
    const params = new URLSearchParams();
 if (status) params.append("status", status);
    if (emailType) params.append("emailType", emailType);
    if (search) params.append("search", search);
    params.append("page", page);
    params.append("pageSize", pageSize);

    return apiClient.get(`/emails?${params.toString()}`);
  },

  /**
   * Get email statistics
   */
  async getStats() {
    return apiClient.get("/emails/stats");
  },

  /**
   * Get a specific email's full details (including HTML body)
   */
  async getEmail(id) {
    return apiClient.get(`/emails/${id}`);
  },

  /**
   * Send a test email to verify SES configuration
   */
  async sendTest({ toEmail, toName = null }) {
    return apiClient.post("/emails/send-test", { toEmail, toName });
  },

  /**
   * Process all pending emails immediately
   */
  async processNow() {
    return apiClient.post("/emails/process-now");
  },

  /**
   * Cancel a pending email
   */
  async cancel(id) {
 return apiClient.post(`/emails/${id}/cancel`);
  },

  /**
   * Retry a failed email
   */
  async retry(id) {
    return apiClient.post(`/emails/${id}/retry`);
  },
};

export default scheduledEmailsApi;
